<template>
  <div class="d-flex flex-column justify-content-center align-items-center col-md-11 router-view-background">
    <div class="col-md-12">
      <the-filters
        :filters="computedFilters"
        :showCleareble="showRedefine"
        @get-model="getFiltersModel"
        @on-cleareble="resetService"
        @search="searchItems"
      />
      <v-btn 
        class="mb-7 birth-button"
        @click="$router.push('/birth-consultation')"
      >
        Consultar Parto
      </v-btn>
      <the-table
        id="birth-list"
        :dataItems="computedBirths"
        :headers="headersForTable"
      >
        <template v-slot:actions="{item}">
          <b-dropdown right id="dropdown-menu-table" text="Corrigir" variant="menu-table" class="m-2 p-0 menu-table">           
            <b-dropdown-item
              v-if="hasPermition"
              class="pr-5 pl-5 b-drop-options"
              variant="text"
              @click="editBirth(item)"
            >
              <i class="mdi mdi-pencil pr-5"></i> Editar Parto
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </the-table>
    </div>
    
    <div class="col-md-12 d-flex justify-content-end">
      <v-pagination
        v-if="birth_pagination ? birth_pagination.total_pages > 1 : 0"
        v-model="page"
        :length="birth_pagination ? birth_pagination.total_pages : 0"
        color="var(--jersey-yellow)"
      ></v-pagination>
    </div>

    <!-- <button-float 
      icon="mdi mdi-plus"
      @event="openSidebar"
    /> -->
    
    <sidebar-birth
      :service="serviceToBirth"
      :matrix="matrixToBirth"
      :edit="editItem"
    />
  </div>
</template>

<script>
import TheTable from "@/components/layout/TheTable";
//import ButtonFloat from "@/components/layout/ButtonFloat";
import {mapMutations, mapState, mapActions} from "vuex";
import {BDropdown, BDropdownItem} from "bootstrap-vue";
import TheFilters from "@/components/layout/TheFilters";

export default {
  name:"BirthList",
  components: {
    TheTable,
    /* ButtonFloat, */
    BDropdown,
    BDropdownItem,
    TheFilters,
    SidebarBirth: () => import("./SidebarBirth.vue")
  },
  data() {
    return {
      headersForTable:[
        {text:"Nome", value:"name_child", sortable:true},
        {text:"Botton", value:"bottom_child", sortable:true},
        {text:"Registro", value:"register_child", sortable:true},
        {text:"Composição Racial", value:"degree_blood", sortable:true},
        {text:"Data", value:"date", sortable:true, type:"date"},
        {text:"Tipo de Parto", value:"kind_birth", sortable:true},
        {text:"", value:"actions", has_slot:true}
      ],
      serviceToBirth:{},
      editItem:{},
      page:1,
      showRedefine:false,
      query:{},
      sidebarOnSecondPlan:false,
      matrixToBirth:{}
    }
  },
  methods: {
    ...mapMutations("sidebar", ["SET_ACTIVE"]),
    ...mapActions("animals", ["actionGetAnimalsBirth"]),
    openSidebar() {
      this.editItem = {};
      this.SET_ACTIVE(true);
    },
    editBirth(value) {
      this.editItem = {...value}; // objeto novo: reabrir o mesmo parto dispara o watcher do sidebar
      this.SET_ACTIVE(true);
    },
    //Esse metodo é especifico para resetar os item iniciais de serviço
    async resetService() {
      await this.actionGetAnimalsBirth({page:1});
      this.query = {};
      this.showRedefine = false;
    },
    getFiltersModel(data) {
      this.query[data.title] = data.value
    },
    //Essa função faz o get dos items da tabela conforme os filtros
    async searchItems() {
      const {animal_description, date, kind_birth} = this.query;
      const payload = {...this.query};
      payload.kind_birth =  this.kinds_birth.find(e => e.id === this.query.kind_birth).name;
      if(animal_description || date || kind_birth) {
        await this.actionGetAnimalsBirth(payload);
        this.showRedefine = true;
      } else {
        this.$toast.warning("Informe ao menos um filtro de pesquisa !");
      }
    },
  },
  computed: {
    ...mapState("animals", [
      "animalsBirth", 
      "kinds_birth", 
      "birth_pagination"
    ]),
    ...mapState("login", [
      "user"
    ]),
    computedBirths() {
      if(this.animalsBirth.length) {
        return this.animalsBirth;
      } else {
        return [];
      }
    },
    //Essa computed vai validar se o usuário pode editar o parto
    hasPermition() {
      if(this.user) {
        if(this.user.attributes.kind === "admin" || this.user.attributes.kind === "partner") {
          return true;
        }
        else {
          return false;
        }
      }
      else {
        return false
      }
    },
    //Essa computed devolve os filtros do componente
    computedFilters() {
      return [
        {name:"animal_description", type:"text", label:"Nome, Registro ou Bottom"},
        {name:"date", type:"date", label:"Data"},
        {name:"kind_birth", type:"select", label:"Tipo de Parto", items:this.kinds_birth}
      ]
    },
  },
  watch: {
    async page(val) {
      await this.actionGetAnimalsBirth({page:val});
    }
  },
  async mounted() {
    await this.actionGetAnimalsBirth({page:1});
    const {service, animal} = this.$route.params;
    if(service && !animal) {
      this.serviceToBirth = {
        id:service.id,
        farm:service.farm_id,
      }
      this.SET_ACTIVE(true);
    }
    else if(service && animal) {
      this.serviceToBirth = {
        id:service.id,
        farm:service.farm_id,
        animal:animal
      }
      this.SET_ACTIVE(true);
    }
  }
}
</script>

<style scoped>
  .birth-button {
    background-color: var(--jersey-yellow) !important;
    color: white;
  }
</style>
